var _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDuoCircleOxygenIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    transform: "rotate(0 0 0)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.4
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.74854 11.9995C8.74854 10.2038 10.2043 8.74805 12 8.74805C13.7957 8.74805 15.2515 10.2038 15.2515 11.9995C15.2515 13.7952 13.7957 15.251 12 15.251C10.2043 15.251 8.74854 13.7952 8.74854 11.9995Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 7.24805C14.6242 7.24805 16.7515 9.37535 16.7515 11.9995C16.7515 14.6237 14.6242 16.751 12 16.751C9.37584 16.751 7.24854 14.6237 7.24854 11.9995C7.24854 9.37535 9.37584 7.24805 12 7.24805Z",
    fill: "currentColor"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.24805 11.9995C7.24805 9.37535 9.37535 7.24805 11.9995 7.24805C14.6237 7.24805 16.751 9.37535 16.751 11.9995C16.751 14.6237 14.6237 16.751 11.9995 16.751C9.37535 16.751 7.24805 14.6237 7.24805 11.9995ZM8.74805 11.9995C8.74805 13.7952 10.2038 15.251 11.9995 15.251C13.7952 15.251 15.251 13.7952 15.251 11.9995C15.251 10.2038 13.7952 8.74805 11.9995 8.74805C10.2038 8.74805 8.74805 10.2038 8.74805 11.9995Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuoCircleOxygenIcon);
export default __webpack_public_path__ + "static/media/DuoCircleOxygenIcon.37cafe3d2875f8301676f3350dd07889.svg";
export { ForwardRef as ReactComponent };